/**
 * @generated SignedSource<<3866db3db8a21a61e9268a318905baa7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleasesIncludedQuery$variables = {
  id: string;
};
export type ReleasesIncludedQuery$data = {
  readonly artist: {
    readonly releasesPrefetch: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ReleaseNode";
          readonly hasExistingInvestmentPartnership: boolean | null;
          readonly hasExistingPartnership: boolean | null;
          readonly id: string;
          readonly tracks: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly soundRecording: {
                  readonly id: string;
                } | null;
              } | null;
            } | null>;
          };
          readonly " $fragmentSpreads": FragmentRefs<"ReleaseSelector_releases" | "ReleasesInfoRemovable_release">;
        } | null;
      } | null>;
    } | null;
    readonly unreleasedReleases: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "UnreleasedReleaseNode";
          readonly hasExistingInvestmentPartnership: boolean | null;
          readonly hasExistingPartnership: boolean | null;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ReleaseSelector_unreleasedReleases" | "ReleasesInfoRemovable_release">;
        } | null;
      } | null>;
    };
  } | null;
};
export type ReleasesIncludedQuery = {
  response: ReleasesIncludedQuery$data;
  variables: ReleasesIncludedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "-releaseDate"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExistingPartnership",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasExistingInvestmentPartnership",
  "storageKey": null
},
v8 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ReleasesInfoRemovable_release"
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SoundRecordingNode",
  "kind": "LinkedField",
  "name": "soundRecording",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "-createdAt"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soundLink",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVisible",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tracksCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trackNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isrc",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReleasesIncludedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArtistNode",
        "kind": "LinkedField",
        "name": "artist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "releasesPrefetch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ReleaseSelector_releases"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TrackNodeConnection",
                        "kind": "LinkedField",
                        "name": "tracks",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrackNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrackNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "releasesPrefetch(first:1000,orderBy:\"-releaseDate\")"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "UnreleasedReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "unreleasedReleases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ReleaseSelector_unreleasedReleases"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "unreleasedReleases(first:1000,orderBy:\"-createdAt\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReleasesIncludedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArtistNode",
        "kind": "LinkedField",
        "name": "artist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "releasesPrefetch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TrackNodeConnection",
                        "kind": "LinkedField",
                        "name": "tracks",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TrackNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrackNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrackNodeConnection",
                                "kind": "LinkedField",
                                "name": "tracks",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TrackNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TrackNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SoundRecordingNode",
                                            "kind": "LinkedField",
                                            "name": "soundRecording",
                                            "plural": false,
                                            "selections": [
                                              (v19/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReleaseNode",
                            "abstractKey": null
                          }
                        ],
                        "type": "ReleaseInterface",
                        "abstractKey": "__isReleaseInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "releasesPrefetch(first:1000,orderBy:\"-releaseDate\")"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "UnreleasedReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "unreleasedReleases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrackNodeConnection",
                                "kind": "LinkedField",
                                "name": "tracks",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TrackNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TrackNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SoundRecordingNode",
                                            "kind": "LinkedField",
                                            "name": "soundRecording",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v19/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReleaseNode",
                            "abstractKey": null
                          }
                        ],
                        "type": "ReleaseInterface",
                        "abstractKey": "__isReleaseInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "unreleasedReleases(first:1000,orderBy:\"-createdAt\")"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a4740ce2a84660212c296a87fa140eb0",
    "id": null,
    "metadata": {},
    "name": "ReleasesIncludedQuery",
    "operationKind": "query",
    "text": "query ReleasesIncludedQuery(\n  $id: ID!\n) {\n  artist(id: $id) {\n    releasesPrefetch(orderBy: \"-releaseDate\", first: 1000) {\n      edges {\n        node {\n          __typename\n          id\n          hasExistingPartnership\n          hasExistingInvestmentPartnership\n          ...ReleasesInfoRemovable_release\n          ...ReleaseSelector_releases\n          tracks {\n            edges {\n              node {\n                soundRecording {\n                  id\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    unreleasedReleases(orderBy: \"-createdAt\", first: 1000) {\n      edges {\n        node {\n          __typename\n          id\n          hasExistingPartnership\n          hasExistingInvestmentPartnership\n          ...ReleasesInfoRemovable_release\n          ...ReleaseSelector_unreleasedReleases\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ReleaseDetails_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  isVisible\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleaseSelector_releases on ReleaseNode {\n  __typename\n  id\n  name\n  releaseDate\n  hasExistingPartnership\n  hasExistingInvestmentPartnership\n  ...Release_release\n}\n\nfragment ReleaseSelector_unreleasedReleases on UnreleasedReleaseNode {\n  __typename\n  id\n  name\n  createdAt\n  hasExistingPartnership\n  hasExistingInvestmentPartnership\n  ...Release_release\n}\n\nfragment Release_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  thumbnailUrl\n  ...ReleaseDetails_release\n}\n\nfragment ReleasesInfoRemovable_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  id\n  soundLink\n  thumbnailUrl\n  name\n  ... on UnreleasedReleaseNode {\n    __typename\n  }\n  ... on ReleaseNode {\n    __typename\n    tracks {\n      edges {\n        node {\n          name\n          trackNumber\n          soundRecording {\n            id\n            isrc\n          }\n          id\n        }\n      }\n    }\n  }\n  ...ReleaseDetails_release\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n"
  }
};
})();

(node as any).hash = "831d5ea1ac3a8aa2b15ab9dea9d10712";

export default node;
